import React, { useEffect, useState } from "react"
import { IBrockmanDetailDto } from "../../../types/brockman/IBrockmanDetailDto"
import { IB64File } from "@/types/IB64File"

export const BrockmanDetailPopUp: React.FC<{
  brockmanDetail: IBrockmanDetailDto
  fieldName: string | undefined
  setFieldName: (val: string | undefined) => void
  label: string
  _submit: (detail: IBrockmanDetailDto | undefined) => void
}> = ({ fieldName, setFieldName, label, _submit, brockmanDetail }) => {
  const [detail, setDetail] = useState<IBrockmanDetailDto | undefined>(brockmanDetail)
  const [val, setVal] = useState<string | undefined | IB64File>(
    detail && fieldName ? detail[fieldName as keyof IBrockmanDetailDto] : ""
  )

  useEffect(() => {
    if (!fieldName) return
    setDetail({ ...detail, [fieldName]: val })
  }, [val])

  useEffect(() => {
    setVal(detail && fieldName ? detail[fieldName as keyof IBrockmanDetailDto] : "")
  }, [fieldName])

  const change = (text: string) => {
    if (!fieldName) return
    setVal(text)
  }

  if (fieldName && typeof val === "string") {
    return (
      <section className="popup-forms">
        <div className="container-popup-forms">
          <button className="close-btn-card" onClick={() => setFieldName(undefined)} />
          <div className="popup-card">
            <h4 className="heading-chapter">{label}</h4>
            <fieldset>
              <legend>{label}</legend>
              <input
                type="text"
                className="input-form"
                placeholder={label}
                onChange={e => change(e.target.value)}
                value={val}
              />
            </fieldset>
            <div className="flex-row-24">
              <button className="btn" onClick={() => _submit(detail)}>
                Сохранить
              </button>
              <button className="btn grey-btn" onClick={() => setFieldName(undefined)}>
                Отменить
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return <></>
  }
}
